import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ServicesLanding from "../views/ServicesLanding";
import Cabinets from "../views/Cabinets";
import Bar from "../views/Bar";
import Furnishing from "../views/Furnishing";
import Wooden from "../views/Wooden";
import Glass from "../views/Glass";
import Interior from "../views/Interior";
import Ceiling from "../views/Ceiling";


export default function Services(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

  
  
	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServicesLanding/>
		} else if(
			appContext.navSubItem === 'cabinets' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Cabinets/>
		} else if(
			appContext.navSubItem === 'bar' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Bar/>
		} else if(
			appContext.navSubItem === 'furnishing' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Furnishing/>
		} else if(
			appContext.navSubItem === 'wooden' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Wooden/>
		} else if(
			appContext.navSubItem === 'glass' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Glass/>
		} else if(
			appContext.navSubItem === 'ceiling' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Ceiling/>
		} else if(
			appContext.navSubItem === 'interior' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Interior/>
		} 
			return null;
	}


	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}